import { defineComponent as y, ref as c, watch as b, computed as t, resolveComponent as z, createElementBlock as s, openBlock as o, normalizeStyle as C, normalizeClass as u, createCommentVNode as k, createTextVNode as w, createElementVNode as S, toDisplayString as $, createBlock as N } from "vue";
import { v as U } from "./vsIcon-Cyr63bPF.mjs";
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const V = y({
  name: "vs-avatar",
  components: {
    vsIcon: U
  },
  props: {
    avatar: { type: [String, Number, Boolean, FileList], default: "" },
    size: { type: Number, default: 50 },
    name: {
      type: String,
      default: ""
      // required: true,
    },
    color: {
      type: String
    },
    background: {
      type: String
    },
    inverted: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !0
    },
    editable: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { emit: n }) {
    const B = [
      "#F44336",
      "#FFEBEE",
      "#FFCDD2",
      "#EF9A9A",
      "#E57373",
      "#EF5350",
      "#F44336",
      "#E53935",
      "#D32F2F",
      "#C62828",
      "#B71C1C",
      "#FF8A80",
      "#FF5252",
      "#FF1744",
      "#D50000",
      "#E91E63",
      "#F48FB1",
      "#F06292",
      "#EC407A",
      "#E91E63",
      "#D81B60",
      "#C2185B",
      "#AD1457",
      "#880E4F",
      "#FF80AB",
      "#FF4081",
      "#F50057",
      "#C51162",
      "#9C27B0",
      "#CE93D8",
      "#BA68C8",
      "#AB47BC",
      "#9C27B0",
      "#8E24AA",
      "#7B1FA2",
      "#6A1B9A",
      "#4A148C",
      "#EA80FC",
      "#E040FB",
      "#D500F9",
      "#AA00FF",
      "#673AB7",
      "#B39DDB",
      "#9575CD",
      "#7E57C2",
      "#673AB7",
      "#5E35B1",
      "#512DA8",
      "#4527A0",
      "#311B92",
      "#B388FF",
      "#7C4DFF",
      "#651FFF",
      "#6200EA",
      "#3F51B5",
      "#9FA8DA",
      "#7986CB",
      "#5C6BC0",
      "#3F51B5",
      "#3949AB",
      "#303F9F",
      "#283593",
      "#1A237E",
      "#8C9EFF",
      "#536DFE",
      "#3D5AFE",
      "#304FFE",
      "#2196F3",
      "#90CAF9",
      "#64B5F6",
      "#42A5F5",
      "#2196F3",
      "#1E88E5",
      "#1976D2",
      "#1565C0",
      "#0D47A1",
      "#82B1FF",
      "#448AFF",
      "#2979FF",
      "#2962FF",
      "#03A9F4",
      "#81D4FA",
      "#4FC3F7",
      "#29B6F6",
      "#03A9F4",
      "#039BE5",
      "#0288D1",
      "#0277BD",
      "#01579B",
      "#80D8FF",
      "#40C4FF",
      "#00B0FF",
      "#0091EA",
      "#00BCD4",
      "#80DEEA",
      "#4DD0E1",
      "#26C6DA",
      "#00BCD4",
      "#00ACC1",
      "#0097A7",
      "#00838F",
      "#006064",
      "#18FFFF",
      "#00E5FF",
      "#00B8D4",
      "#009688",
      "#80CBC4",
      "#4DB6AC",
      "#26A69A",
      "#009688",
      "#00897B",
      "#00796B",
      "#00695C",
      "#004D40",
      "#64FFDA",
      "#1DE9B6",
      "#00BFA5",
      "#4CAF50",
      "#A5D6A7",
      "#81C784",
      "#66BB6A",
      "#4CAF50",
      "#43A047",
      "#388E3C",
      "#2E7D32",
      "#1B5E20",
      "#69F0AE",
      "#00E676",
      "#00C853",
      "#8BC34A",
      "#AED581",
      "#9CCC65",
      "#8BC34A",
      "#7CB342",
      "#689F38",
      "#558B2F",
      "#33691E",
      "#B2FF59",
      "#76FF03",
      "#64DD17",
      "#CDDC39",
      "#DCE775",
      "#D4E157",
      "#CDDC39",
      "#C0CA33",
      "#AFB42B",
      "#9E9D24",
      "#827717",
      "#EEFF41",
      "#C6FF00",
      "#AEEA00",
      "#FFEB3B",
      "#FFEE58",
      "#FFEB3B",
      "#FDD835",
      "#FBC02D",
      "#F9A825",
      "#F57F17",
      "#FFEA00",
      "#FFD600",
      "#FFC107",
      "#FFD54F",
      "#FFCA28",
      "#FFC107",
      "#FFB300",
      "#FFA000",
      "#FF8F00",
      "#FF6F00",
      "#FFD740",
      "#FFC400",
      "#FFAB00",
      "#FF9800",
      "#FFB74D",
      "#FFA726",
      "#FF9800",
      "#FB8C00",
      "#F57C00",
      "#EF6C00",
      "#E65100",
      "#FFD180",
      "#FFAB40",
      "#FF9100",
      "#FF6D00",
      "#FF5722",
      "#FFAB91",
      "#FF8A65",
      "#FF7043",
      "#FF5722",
      "#F4511E",
      "#E64A19",
      "#D84315",
      "#BF360C",
      "#FF9E80",
      "#FF6E40",
      "#FF3D00",
      "#DD2C00",
      "#795548",
      "#A1887F",
      "#8D6E63",
      "#795548",
      "#6D4C41",
      "#5D4037",
      "#4E342E",
      "#3E2723",
      "#9E9E9E",
      "#BDBDBD",
      "#9E9E9E",
      "#757575",
      "#616161",
      "#424242",
      "#212121",
      "#607D8B",
      "#B0BEC5",
      "#90A4AE",
      "#78909C",
      "#607D8B",
      "#546E7A",
      "#455A64",
      "#37474F",
      "#263238"
    ], E = c(!!e.avatar);
    b(() => e.avatar, () => {
      E.value = !!e.avatar;
    });
    const A = t(() => `background-image: url('${e.avatar}'); width: ${e.size}px; height: ${e.size}px`), D = t(() => {
      const F = e.size || 40;
      return l.value.length == 1 ? F / 2 : l.value.length == 2 ? F / 2.5 : l.value.length == 3 ? F / 3 : 14;
    }), l = t(() => {
      var a;
      let F = (a = e.name) == null ? void 0 : a.trim().split(/[- ]/);
      return F = F.filter((r) => r !== ""), F.length >= 3 ? F[0][0].toUpperCase() + F[1][0].toUpperCase() + F[F.length - 1][0].toUpperCase() : F.length == 2 ? F[0][0].toUpperCase() + F[1][0].toUpperCase() : F.length == 1 ? F[0][0].toUpperCase() : "";
    }), i = t(() => B[m.value % B.length]), g = t(() => e.background ? e.background : i), p = t(() => e.color ? e.color : i), m = t(() => {
      var r;
      const F = (r = e.name) == null ? void 0 : r.trim();
      let a = 0;
      for (let d = 0; d < F.length; d++)
        a += F.charCodeAt(d);
      return a;
    }), v = (F) => {
      var r;
      const a = F.target.files || F.dataTransfer && ((r = F.dataTransfer) == null ? void 0 : r.files);
      n("avatar:upload", a), a && h(a[0]);
    }, h = (F) => {
      var a = new FileReader();
      a.readAsDataURL(F), a.onload = () => {
        var r;
        ((r = a.result) == null ? void 0 : r.indexOf("data:image")) !== -1 && (f.value = a.result);
      }, a.onerror = function(r) {
        console.log("Error: ", r);
      };
    }, f = c();
    return { getStyle: A, displayColor: p, displayName: l, avatarExists: E, fontSize: D, displayBackground: g, handleFile: v, currentFile: f };
  }
}), R = ["src"], T = ["src"];
function L(e, n, B, E, A, D) {
  const l = z("vs-icon");
  return o(), s("label", {
    class: u([e.editable ? "cursor-pointer" : "", "block bg-no-repeat bg-cover text-on-primary rounded-full shadow"]),
    style: C({
      width: e.size + "px",
      height: e.size + "px"
    })
  }, [
    e.avatarExists || e.name ? (o(), s("div", {
      key: 0,
      class: u([e.editable ? "hover:brightness-75" : "", "bg-no-repeat bg-cover border-2 border-white text-on-primary flex items-center justify-center font-bold"]),
      style: C({
        width: e.size + "px",
        height: e.size + "px",
        fontSize: e.fontSize + "px",
        "background-image": e.avatarExists && `url('${e.avatar}')`,
        "background-color": !e.avatarExists && `${e.displayBackground.value}`,
        display: e.inline && "inline-flex",
        borderRadius: e.rounded && "50%"
      })
    }, [
      w($(e.avatarExists ? "" : e.displayName) + " ", 1),
      S("img", {
        class: "hidden",
        src: e.avatar,
        onError: n[0] || (n[0] = (i) => e.avatarExists = !1)
      }, null, 40, R)
    ], 6)) : (o(), s("div", {
      key: 1,
      class: "border-2 border-surface bg-surface rounded-full flex justify-center items-center overflow-hidden",
      style: C({
        width: e.size + "px",
        height: e.size + "px"
      })
    }, [
      e.currentFile ? (o(), s("img", {
        key: 0,
        class: "w-full h-full object-cover",
        src: e.currentFile
      }, null, 8, T)) : (o(), N(l, {
        key: 1,
        class: u([e.editable ? "hover:opacity-80" : "", "opacity-50"]),
        name: "carbon:user-avatar-filled",
        color: "primary",
        size: e.size
      }, null, 8, ["class", "size"]))
    ], 4)),
    e.editable ? (o(), s("input", {
      key: 2,
      ref: "file",
      type: "file",
      accept: "image/jpeg,image/png,image/tiff,image/webp,image/gif",
      class: "absolute left-0 w-5/12 invisible pointer-events-none",
      onChange: n[1] || (n[1] = (...i) => e.handleFile && e.handleFile(...i))
    }, null, 544)) : k("", !0)
  ], 6);
}
const G = /* @__PURE__ */ j(V, [["render", L]]);
export {
  G as v
};
//# sourceMappingURL=vsAvatar-SOtko3H3.mjs.map
